import './access-privilege.component.scss';

import { useEffect, useState, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';

import { organizationType } from 'const/nuclias/organization';
import SiteTagOrSiteDropdownList from './SiteTagOrSiteDropdownList';
import DropdownWithItem from '../DropdownWithItem';

export const accessLevelType = {
  org: organizationType.org,   // ORGANIZATION
  tag: organizationType.tag,   // STORETAG
  site: organizationType.site // STORE
};

const accessLevelList = [
  { id: 0, title: 'c1ca926603', isActive: true, accessLevel: organizationType.org },   // Organization
  { id: 1, title: '3039a00fca', isActive: false, accessLevel: organizationType.tag },  // Site tag
  { id: 2, title: 'a7d6475ec8', isActive: false, accessLevel: organizationType.site } // Site
];

const accessLevelListTagUser = [
  { id: 0, title: '3039a00fca', isActive: true, accessLevel: organizationType.tag },    // Site tag
  { id: 1, title: 'a7d6475ec8', isActive: false, accessLevel: organizationType.site }, // Site
];

const accessLevelListSiteUser = [
  { id: 0, title: 'a7d6475ec8', isActive: true, accessLevel: organizationType.site },  // Site
];

const AccessPrivilege = props => {
  const {
    id,
    accessLevel = organizationType.org,
    seletedAccessLevel, // "ORGANIZATION" || STORETAG || STORE
    siteTagList = [],
    siteList = [],
    disabled,
    onChangeSelectedLevelItem,
    onChangeSelectedItem
  } = props;
  const { t } = useTranslation();
  const [tmpAccessLevel, setTmpAccessLevel] = useState(cloneDeep(accessLevelList));

  const selectedAccessLevelIndex = tmpAccessLevel.findIndex(item => !!item.isActive);
  const getNewDefaultSelectedAccessLevel = levelList => {

    const tmpLevelList = cloneDeep(levelList);
    const tmpSeletedLevel = seletedAccessLevel || tmpLevelList[0].accessLevel;
    tmpLevelList.forEach(item => item.isActive = item.accessLevel.toLowerCase() === tmpSeletedLevel.toLowerCase());

    return tmpLevelList;
  }

  useEffect(() => {
    switch (accessLevel) {
      case organizationType.tag:
        setTmpAccessLevel(getNewDefaultSelectedAccessLevel(accessLevelListTagUser));
        break;
      case organizationType.site:
        setTmpAccessLevel(getNewDefaultSelectedAccessLevel(accessLevelListSiteUser));
        break;
      default:
        setTmpAccessLevel(getNewDefaultSelectedAccessLevel(accessLevelList));
        break;
    }
  }, [accessLevel, seletedAccessLevel]);

  const checkSelectedItem = event => {
    const newAccessLevel = tmpAccessLevel.map(item => {
      if (event?.title === item.title) {
        return { ...item, isActive: true };
      } else {
        return { ...item, isActive: false };
      }
    });
    setTmpAccessLevel(newAccessLevel);
  };

  return (
    <>
      {/* Access privilege */}
      <div className={'sub-title mt-3 mb-3'}>{t('8f1bd444d2')}</div>
      <div className="mb-2">
        {/* Access level */}
        <div className={'access-privilege-text'}>{t('de88250cdc')}</div>
        <DropdownWithItem
          id="used-unused-dropdown"
          selectedItem={tmpAccessLevel[selectedAccessLevelIndex]}
          itemList={tmpAccessLevel}
          onClick={item => {
            checkSelectedItem(item);

            const selectedLevelItem = item.accessLevel === organizationType.org ? null : item;
            onChangeSelectedLevelItem && onChangeSelectedLevelItem(selectedLevelItem);
          }}
        />
      </div>

      {/* Managed Site tag */}
      {accessLevel !== organizationType.site &&
        tmpAccessLevel[accessLevel !== organizationType.org ? 0 : 1]?.isActive === true && (
          <SiteTagOrSiteDropdownList
            id={id}
            tmpAccessLevel={organizationType.tag}
            itemList={siteTagList}
            disabled={disabled}
            onChangeSelectedItem={onChangeSelectedItem}
          />
        )}

      {/* Managed Site */}
      {accessLevel !== organizationType.site &&
        tmpAccessLevel[accessLevel !== organizationType.org ? 1 : 2]?.isActive === true && (
          <SiteTagOrSiteDropdownList
            id={id}
            tmpAccessLevel={organizationType.site}
            itemList={siteList}
            disabled={disabled}
            onChangeSelectedItem={onChangeSelectedItem}
          />
        )}
    </>
  );
};

export default memo(AccessPrivilege);
